import * as angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import { mxShellErrorMessageComponent } from './mx-shell-error-message/mx-shell-error-message';
import { errorPageState } from './error-page.states';
import { ErrorPosterService } from './error-poster.service';

export const errorPageModule = angular
	.module('mx.sb.ErrorPage', [uiRouter])
	.component(errorPageState.component, mxShellErrorMessageComponent)
	.service('mx.sb.ErrorPage.PosterService', ErrorPosterService);
